module.exports = __webpack_public_path__ + "17c25bb26906eb31fe3bcf8d85cda00c.png";